import { type ReactNode } from 'react';

import { LogoWithName } from '@/shared/components/theme/logo-with-name';
import { Button, buttonVariants } from '@/shared/components/ui/button';
import { Link } from '@/shared/components/ui/link';
import { cn } from '@/shared/utils/cn';

interface AuthAction {
  label: string;
  href?: string;
  onClick?: () => void;
  variant?: 'default' | 'outline' | 'ghost' | 'link';
  icon?: ReactNode;
}

interface AuthHeaderProps {
  actions?: AuthAction[];
}

export const AuthHeader = ({ actions = [] }: AuthHeaderProps) => {
  return (
    <header className="flex w-full flex-row items-start justify-between gap-4 py-3 sm:gap-0 sm:py-4">
      <div className="scale-75 sm:scale-100">
        <LogoWithName />
      </div>
      <div className="flex flex-1 flex-row justify-end gap-4 lg:mr-32">
        {actions.map((action, index) =>
          action.href ? (
            <Link
              key={`auth-action-${index}`}
              to={action.href}
              className={cn(
                buttonVariants({
                  variant: action.variant || 'outline',
                  btnType: 'secondary',
                }),
              )}
            >
              {action.icon}
              <span className="sm:inline">{action.label}</span>
            </Link>
          ) : (
            <Button
              key={`auth-action-${index}`}
              variant={action.variant || 'outline'}
              onClick={action.onClick}
            >
              {action.icon}
              <span className="sm:inline">{action.label}</span>
            </Button>
          ),
        )}
      </div>
    </header>
  );
};
